import React from 'react';
import { useTranslation } from 'react-i18next';

import '../../../assets/login.css';

const Header = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="login-header w-100">
      <div className="container container-ll">
        <div className="d-flex justify-content-between">
          <div style={{ width: '80px' }}>
            <img src="/assets/images/logo.png" className="mt-4 mb-4 " alt="logo" style={{ width: '100%' }} />
          </div>
          <div className="d-flex align-items-center">
            <div className="personal-information-language font-weight-bold link-enable">{t('languages.fr')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
